// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__I31kF","validationTips":"StatementDescriptor_validationTips__bJTVK"};